import { MatriculaSidebarService } from '../../services/matriculas-sidebar.service';
import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ServidorSelecionadoService } from './servidor-selecionado.service';

@Component({
  selector: 'rh-servidor-sidebar',
  templateUrl: './servidor-sidebar.component.html',
  styleUrls: ['./servidor-sidebar.component.css']
})
export class ServidorSidebarComponent implements OnInit {

  public form: UntypedFormGroup;
  public active: boolean = false;
  public showNavBar: boolean = false;

  public matriculas;
  public servidorSelecionado: any = null;

  @Input() menuPrincipal: any;
  @Output() idEntidadeSelecionada: EventEmitter<number> = new EventEmitter();

  private _currentY = 0;
  private _initialY = 0;
  private _element: any;
  private _positionChanged = false;

  constructor(
    private _servidorSelecionadoService: ServidorSelecionadoService,
    private _router: Router,
    private matriculaSidebarService: MatriculaSidebarService) {

    this._servidorSelecionadoService.onSelecionarFuncionario().subscribe(servidor => {
      this.servidorSelecionado = servidor;
    });
  }

  public ngOnInit(): void {
    this.matriculas = this.matriculaSidebarService.getMatriculas();
    if (this.matriculas.length > 1) {
      this.showNavBar = true;

      setTimeout(() => {
        this._element = document.getElementById('botao-abrir-sidebar-funcionario');
        this._dragElement(this._element);
      }, 0);
    }
  }

  public onClickActivateButton() {
    if (this._positionChanged) {
      return;
    }
    this.openCloseTheBar();
  }

  @HostListener('document:click', ['$event'])
  public clickedOutside($event) {
    if (this.active) {

      let parents = $event.path;
      if (!parents) {
        return;
      }
      let isFuncionarioSidebarOpen = false;

      if (parents && parents.length > 0 && parents[0].localName === 'app-root') {
        isFuncionarioSidebarOpen = true;
      }

      parents.map(parent => {
        if (parent && parent.classList && parent.classList.value) {
          if (parent.classList.value.includes('float-sidebar')) {
            isFuncionarioSidebarOpen = true;
          }
        }
      });

      if (!isFuncionarioSidebarOpen && this.active) {
        this._close();
      }
    }
  }

  @HostListener('document:keydown', ['$event'])
  public handleKeyboardEvent(event: KeyboardEvent) {
    if (this.ctrlAltF(event)) {
      this.openCloseTheBar();
      return;
    }
    if (event.code === 'Escape' && this.active) {
      this._close();
    }
  }

  public selecionarFuncionario(funcionario: any) {
    if (this.servidorSelecionado && this.servidorSelecionado.id === funcionario.id) {
      this.openCloseTheBar();
      return;
    }

    this.servidorSelecionado = funcionario;
    const userInfo = this.matriculaSidebarService.getUserInfo();
    this.matriculaSidebarService.changeMatricula(userInfo, this.servidorSelecionado);
    this.idEntidadeSelecionada.emit(funcionario?.entidade);
    this.openCloseTheBar();
    this._goHome();
  }


  public getServidorIdSelected() {
    return this.servidorSelecionado ? this.servidorSelecionado.id : null;
  }

  public openCloseTheBar() {
    this.active = !this.active;
  }

  @HostListener('window:resize')
  onResize() {
    if (this._element && this._element.style) {
      this._element.style.top = '0px';
    }
  }

  private _goHome() {
    this._router.navigateByUrl(`/home`);
  }

  /* tslint:disable */
  private _dragMouseDown = (e) => {
    e = e || window.event;
    e.preventDefault();
    // get the mouse cursor position at startup:
    this._initialY = e.clientY;
    this._positionChanged = false;
    document.onmouseup = this._closeDragElement;
    // call a function whenever the cursor moves:
    document.onmousemove = this._elementDrag;
  };

  private _calcularPosicao() {
    let offsetFinal = (this._element.offsetTop - this._currentY);
    let limiteTopo = ((window.innerHeight - 230) / 2) + offsetFinal;
    let limiteRodape = ((window.innerHeight + 130) / 2) + offsetFinal;
    // set the element's new position:
    let offSetAnterior = +this._element.style.top.replace('px', '');
    if (offSetAnterior != offsetFinal && limiteTopo > 0 && limiteRodape < window.innerHeight) {
      this._element.style.top = offsetFinal + 'px';
      this._positionChanged = true;
    }
  }

  private _elementDrag = (e) => {
    e = e || window.event;
    e.preventDefault();
    // calculate the new cursor position:
    this._currentY = this._initialY - e.clientY;
    this._initialY = e.clientY;
    // Define the limit of the moving
    this._calcularPosicao();
    //this._element.style.left = (this._element.offsetLeft - this._pos1) + 'px';
  };

  private _closeDragElement = () => {
    /* stop moving when mouse button is released:*/
    document.onmouseup = null;
    document.onmousemove = null;
  };

  /* tslint:enable */

  private _dragElement(element) {
    if (document.getElementById(element.id)) {
      // if present, the header is where you move the DIV from:
      document.getElementById(element.id).onmousedown = this._dragMouseDown;
    } else {
      // otherwise, move the DIV from anywhere inside the DIV:
      element.onmousedown = this._dragMouseDown;
    }
  }

  private ctrlAltF(event: KeyboardEvent) {
    return event.code === 'KeyF' &&
      event.ctrlKey &&
      event.altKey;
  }

  private _close() {
    this.active = false;
  }
}
